/**
 * Genera un tag <img> para iconos SVG del admin panel.
 * SSOT — todos los módulos importan de aquí.
 *
 * attrs (opcional): atributos HTML extra — id, style, title, etc. — para los
 * casos que necesitan un ícono direccionable por JS (ej. toggle de password)
 * o con tamaño/posición custom. Sin whitelist de claves: el caller controla
 * el HTML igual que antes de existir este helper, solo se centraliza el tag.
 */
// SSOT tipo de nodo → nombre de ícono (mismo glifo en árbol, ficha y listados).
// El Promotor Digital NO va acá: su ícono lo declara su perfil (perfiles/promotor-digital.js).
const ICONO_POR_TIPO_DE_NODO = {
    operador: 'building-2',
    representante: 'user',
    punto_venta: 'store',
};

/** Ícono del tipo de nodo (operador/representante/punto_venta), listo para inyectar. */
export function iconoDeTipoDeNodo(tipo) {
    return icon(ICONO_POR_TIPO_DE_NODO[tipo] || 'box');
}

export function icon(name, className = '', attrs = {}) {
    const cls = className ? `icon ${className}` : 'icon';
    const extra = Object.entries(attrs)
        .map(([k, v]) => ` ${k}="${v}"`)
        .join('');
    // onerror: si el SVG no existe (nombre dinámico de config, typo), ocultar el
    // <img> en vez de mostrar el glifo de imagen rota que ensucia la estética.
    // Defensa de raíz — los nombres rotos conocidos igual se corrigen en su origen.
    return `<img src="/assets/icons/${name}.svg" class="${cls}" alt=""${extra} onerror="this.style.visibility='hidden'">`;
}
